module.exports = __webpack_public_path__ + "img/function-image-change.c14c44cf.svg";